import axiosInstance from "../../axiosInstanceSetup";
import { LOAD_API_DATA, SET_API_DATA } from "./alert.type";

export const getAlerts = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "alertList" },
        });
        
        axiosInstance.get(`${endpoint}${process.env.REACT_APP_ALERTS}?data_asset_id=${assetId}`)
            .then(response => {
              
                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "alertList",
                            data:response.data.alerts,
                            status: "success",
                        },
                    })
                    
                }
            })
            .catch(error => {
                // Handle error
                console.error('Error:', error);
            });
    };
};
// export const ruleRecommendation = (dataAssetId) => {
//     return async (dispatch, getState, { endpoint }) => {
//         dispatch({
//             type: LOAD_API_DATA,
//             payload: { apiField: "recommendateRule" },
//         });

//         axiosInstance.get(`${endpoint}${process.env.REACT_APP_API_RULE_RECOMMEND}`
//             , {
//                 params: { asset_id: dataAssetId }
//             }
//         )
//             .then(response => {
//                 // Handle success
//                 console.log("recommendateRule")
//                 console.log(response)
//                 if (response.data.status === "success") {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "recommendateRule",
//                             data: response.data.data,
//                             status: "success",
//                         },
//                     })

//                 }
//             })
//             .catch(error => {
//                 // Handle error
//                 console.error('Error:', error);
//             });
//     };
// };
// export const getSampleData = (assetId) => {
//     return async (dispatch, getState, { endpoint }) => {
//         dispatch({
//             type: LOAD_API_DATA,
//             payload: { apiField: "sampleData" },
//         });
//         axiosInstance.get(`${endpoint}${process.env.REACT_APP_GET_SAMPLE_DATA}${assetId}`
//             //   ,{
//             //   params:{asset_id :dataAssetId}
//             // }
//         )
//             .then(response => {
//                 // Handle success
//                 console.log("single data asset")
//                 console.log(response)
//                 if (response.data.status === "success") {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "sampleData",
//                             data: response.data.sample_data,
//                             status: "success",
//                         },
//                     })

//                 } else {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "sampleData",
//                             data: [],
//                             status: response.data.data.status,
//                         },
//                     })
//                 }
//             })
//             .catch(error => {
//                 // Handle error
//                 console.error('Error:', error);
//                 dispatch({
//                     type: SET_API_DATA,
//                     payload: {
//                         apiField: "sampleData",
//                         data: [],
//                         status: "fail",
//                     },
//                 })
//             });
//     };
// };
// export const getdataAssetProfile = (assetId) => {
//     return async (dispatch, getState, { endpoint }) => {
//         dispatch({
//             type: LOAD_API_DATA,
//             payload: { apiField: "profileCde" },
//         });
//         axiosInstance.get(`${endpoint}${process.env.REACT_APP_API_GET_PROFILING}${assetId}`
//             //   ,{
//             //   params:{asset_id :dataAssetId}
//             // }
//         )
//             .then(response => {
//                 // Handle success
//                 console.log("profiling cde")
//                 console.log(response.data.data.attribute_metadata.map((val) => {
//                     return { ...val, attribute_details: JSON.parse(val.attribute_details) }
//                 }))
//                 // if (response.data.status === "success") {
//                 dispatch({
//                     type: SET_API_DATA,
//                     payload: {
//                         apiField: "profileCde",
//                         data: response.data.data.attribute_metadata.map((val) => {
//                             return { ...val, attribute_details: JSON.parse(val.attribute_details) }
//                         }),
//                         status: "success",
//                     },
//                 })

//                 // }
//             })
//             .catch(error => {
//                 // Handle error
//                 console.error('Error:', error);
//             });
//     };
// };
// export const rundataAssetProfiler = (assetId) => {
//     return async (dispatch, getState, { endpoint }) => {
//         dispatch({
//             type: LOAD_API_DATA,
//             payload: { apiField: "runProfiler" },
//         });
//         axiosInstance.post(`${endpoint}${process.env.REACT_APP_API_RUN_PROFILING}${assetId}/1`)
//             .then(response => {
//                 // Handle success

//                 if (response.data.status === "success") {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "runProfiler",
//                             data: response.data.message,
//                             status: "success",

//                         },
//                     })

//                 } else {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "runProfiler",
//                             data: response.data.message,
//                             status: response.data.status,

//                         },
//                     })
//                 }
//             })
//             .catch(error => {
//                 // Handle error
//                 dispatch({
//                     type: SET_API_DATA,
//                     payload: {
//                         apiField: "runProfiler",
//                         data: [],
//                         status: "error",
//                         message: "Process interrupt due to some technical issue."
//                     },
//                 })
//                 console.error('Error:', error);
//             });
//     };
// };
export const submitAlert = (assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const {formData } = getState().alert;
    
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "submitingAlert" },
        });
        axiosInstance.post(`${endpoint}${process.env.REACT_APP_ALERTS}`, {
                
                "data_asset_id": assetId,
                "alert_type": formData.alert_type.value.toUpperCase(),
                "alert_config": formData.alert_type.value.toUpperCase() === "EMAIL"?JSON.stringify({email:formData.email.value}):JSON.stringify({'channel_name': formData.channel_name.value, 'webhook_link': formData.weebhook_link.value}),
                "is_active": formData. activateAlert.value,
                "created_date": new Date(),
                "created_by": localStorage.getItem("userId"),
                "last_modified": new Date(),
                "last_modified_by": localStorage.getItem("userId"),
                // "end_date": "2025-03-18T13:07:10.308Z"
              

        })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitingAlert",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitingAlert",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getAlerts(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "submitingAlert",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    }
}
export const EditAlert = (alertId,assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const {formData } = getState().alert;
    
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "submitingAlert" },
        });
        axiosInstance.put(`${endpoint}${process.env.REACT_APP_ALERTS}/${alertId}`, {
                "data_asset_id": assetId,
                "alert_type": formData.alert_type.value.toUpperCase(),
                "alert_config": formData.alert_type.value.toUpperCase() === "EMAIL"?JSON.stringify({email:formData.email.value}):JSON.stringify({'channel_name': formData.channel_name.value, 'webhook_link': formData.weebhook_link.value}),
                "is_active": formData. activateAlert.value,
                "last_modified": new Date(),
                "last_modified_by": localStorage.getItem("userId"),
           })
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitingAlert",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "submitingAlert",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getAlerts(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "submitingAlert",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    }
}

export const deleteAlert = (alertId,assetId) => {
    return async (dispatch, getState, { endpoint }) => {
        const {formData } = getState().alert;
    
        dispatch({
            type: LOAD_API_DATA,
            payload: { apiField: "deletingAlert" },
        });
        axiosInstance.delete(`${endpoint}${process.env.REACT_APP_ALERTS}/${alertId}`)
            .then(response => {
                // Handle success

                if (response.data.status === "success") {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "deletingAlert",
                            data: response.data.message,
                            status: "success",

                        },
                    })

                } else {
                    dispatch({
                        type: SET_API_DATA,
                        payload: {
                            apiField: "deletingAlert",
                            data: response.data.message,
                            status: response.data.status,

                        },
                    })
                }
                dispatch(getAlerts(assetId))
            })
            .catch(error => {
                // Handle error
                dispatch({
                    type: SET_API_DATA,
                    payload: {
                        apiField: "deletingAlert",
                        data: [],
                        status: "error",
                        message: "Process interrupt due to some technical issue."
                    },
                })
                console.error('Error:', error);
            });
    }
}
// export const submitSelectedRuleRecommendation = () => {
//     return async (dispatch, getState, { endpoint }) => {
//         const { dataAsset: { formData, apiData } } = getState();
//         dispatch({
//             type: LOAD_API_DATA,
//             payload: { apiField: "recommendateRule" },
//         });
//         axiosInstance.post(`${endpoint}${process.env.REACT_APP_SUBMIT_SELECTED_RECOMMENDATION}`, {
//             // params: {

//             "data_asset_id": apiData.assetSummary.data.data_asset_id,
//             selectedrecommendation: formData.selectedRules.options.map((val) => {
//                 return ({
//                     "dataframe_id": val.dataframe_id,
//                     "data_attribute_id": val.attribute_id,
//                     "rule_name": val.rule_name,
//                     "rule_description": val.rule_description,
//                     "check_name": val.check_name,
//                     "is_active": val.is_active,
//                     "created_date": val.created_date,
//                     "created_by": val.created_by,
//                     "last_modified_by": val.last_modified_by,
//                     "end_date": val.end_date
//                 })
//             })


//         })
//             .then(response => {
//                 // Handle success

//                 if (response.data.status === "success") {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "recommendateRule",
//                             data: response.data.message,
//                             status: "success",

//                         },
//                     })

//                 } else {
//                     dispatch({
//                         type: SET_API_DATA,
//                         payload: {
//                             apiField: "runProfiler",
//                             data: response.data.message,
//                             status: response.data.status,

//                         },
//                     })
//                 }
//             })
//             .catch(error => {
//                 // Handle error
//                 dispatch({
//                     type: SET_API_DATA,
//                     payload: {
//                         apiField: "recommendateRule",
//                         data: [],
//                         status: "error",
//                         message: "Process interrupt due to some technical issue."
//                     },
//                 })
//                 dispatch(ruleRecommendation(formData.selectedProfile.options[0].data_asset_id))
//                 console.error('Error:', error);
//             });
//     }
// }